import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { editProperty } from '../../../Redux/Actions/actions'; // Asegúrate de ajustar la ruta según tu estructura de proyecto
import style from './EditModal.module.css';

const EditModal = ({ property, onClose }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    precioCierre: property.cerrado.precioCierre || '',
    currencyCierre: property.cerrado.currencyCierre || '',
    fecha: property.cerrado.fecha || '',
    soldByAgent: property.cerrado.soldByAgent || false,
    buyingTip: property.cerrado.buyingTip || false,
    selleringTip: property.cerrado.selleringTip || false,
    sellerCommision: property.cerrado.sellerCommision || '',
    officeComission: property.cerrado.officeComission || '',
    totalComission: property.cerrado.totalComission || '',
    franquiciaComission: property.cerrado.franquiciaComission || '',
    martillerComission: property.cerrado.martillerComission || '',
    cierre: property.cerrado.cierre || false, // Nuevo campo para indicar si está cerrado
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(editProperty(property.id, { cerrado: formData }));
    onClose();
  };

  return (
    <div className={style.modalOverlay}>
      <div className={style.modal}>
        <button className={style.closeButton} onClick={onClose}>X</button>
        <h2>Editar Datos de Cierre</h2>
        <form onSubmit={handleSubmit}>
          <label>
            Precio de Cierre:
            <input
              type="text"
              name="precioCierre"
              value={formData.precioCierre}
              onChange={handleChange}
            />
          </label>
          <label>
            Moneda de Cierre:
            <input
              type="text"
              name="currencyCierre"
              value={formData.currencyCierre}
              onChange={handleChange}
            />
          </label>
          <label>
            Fecha de Cierre:
            <input
              type="date"
              name="fecha"
              value={formData.fecha}
              onChange={handleChange}
            />
          </label>
          <label>
            Vendido por Agente:
            <input
              type="checkbox"
              name="soldByAgent"
              checked={formData.soldByAgent}
              onChange={handleChange}
            />
          </label>
          <label>
            Punta Compradora:
            <input
              type="checkbox"
              name="buyingTip"
              checked={formData.buyingTip}
              onChange={handleChange}
            />
          </label>
          <label>
            Punta Vendedora:
            <input
              type="checkbox"
              name="selleringTip"
              checked={formData.selleringTip}
              onChange={handleChange}
            />
          </label>
          <label>
            Comisión Vendedor:
            <input
              type="text"
              name="sellerCommision"
              value={formData.sellerCommision}
              onChange={handleChange}
            />
          </label>
          <label>
            Comisión Oficina:
            <input
              type="text"
              name="officeComission"
              value={formData.officeComission}
              onChange={handleChange}
            />
          </label>
          <label>
            Comisión Total:
            <input
              type="text"
              name="totalComission"
              value={formData.totalComission}
              onChange={handleChange}
            />
          </label>
          <label>
            Comisión Franquicia:
            <input
              type="text"
              name="franquiciaComission"
              value={formData.franquiciaComission}
              onChange={handleChange}
            />
          </label>
          <label>
            Comisión Martillero:
            <input
              type="text"
              name="martillerComission"
              value={formData.martillerComission}
              onChange={handleChange}
            />
          </label>
          <label>
            ¿Propiedad Vendida?:
            <input
              type="checkbox"
              name="cierre"
              checked={formData.cierre}
              onChange={handleChange}
            />
          </label>
          <button type="submit">Guardar Cambios</button>
        </form>
      </div>
    </div>
  );
};

export default EditModal;